<template>
  <div
    v-if="hasValidQRCode"
    class="qrcode-wrapper"
    :class="{
      'fullscreen': isFullScreen,
      [`position-${posicaoEnquete}`]: true
    }"
  >
    <div class="qrcode-container">
      <BaseQRCode class="qrcode-bg" preserveAspectRatio="none" />
      <img
        :src="item.enquete_qr_code.url"
        :alt="qrCodeAltText"
        class="qrcode-image"
        @error="onQRCodeError"
      />
    </div>
    <div class="participe-label">
      <ParticipeQRCode class="participe-bg" preserveAspectRatio="none" />
      <!-- <span>Participe!</span> -->
    </div>
  </div>
</template>

<script>
import BaseQRCode from '@/assets/tarjas/F1Sportv/BASE_QR_CODE.svg';
import ParticipeQRCode from '@/assets/tarjas/F1Sportv/PARTICIPE_QR_CODE.svg';

export default {
  name: 'CardTarjaEnqueteF1GloboQRCODE',
  components: {
    BaseQRCode,
    ParticipeQRCode
  },
  props: {
    item: {
      type: Object,
      default: () => null
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    posicaoEnquete: {
      type: String,
      default: 'esquerda'
    },
  },
  computed: {
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
    qrCodeAltText() {
      return `QR Code - ${this.item?.dsc_titulo_enquete || 'Participe da Enquete'}`;
    }
  },
  methods: {
    onQRCodeError(event) {
      console.error('Error loading QR Code image:', event);
      this.$emit('qrcode-error', {
        url: this.item?.enquete_qr_code?.url,
        enqueteId: this.item?.id
      });
    }
  }
}
</script>

<style scoped lang="scss">
@font-face {
  font-family: "GaleanaStandard-Black";
  src: url("@/assets/fonts/TrocaDePasseSportv/GaleanaStandard-Black.otf") format("opentype");
}

.qrcode-wrapper {
  --participe-label-background-gradient: linear-gradient(to top, #f9e8dd, #fcfcfc);
  --participe-label-text: #450326;

  position: fixed;
  bottom: 85px;
  left: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  max-width: none;
  margin: 0;
  transition: all 0.3s ease;
  z-index: 100;

  &.fullscreen {
    max-width: 400px;
  }

  &.position-esquerda {
    align-self: flex-start;
  }

  &.position-direita {
    align-self: flex-end;
    left: auto;
    right: 60px;
  }

  &.position-centro {
    align-self: center;
    left: 50%;
    transform: translateX(-50%);
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: 148px;
  height: 148px;
  position: relative;

  .qrcode-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    z-index: 0;
  }
}

.qrcode-image {
  width: 124px;
  height: 124px;
  object-fit: contain;
  position: relative;
  z-index: 1;
}

.participe-label {
  width: 148px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -4px;
  position: relative;

  .participe-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  span {
    display: block;
    font-family: 'GaleanaStandard-Black', sans-serif;
    font-size: 22px;
    color: var(--participe-label-text);
    text-align: center;
  }
}
</style>
